export default __webpack_public_path__ + "static/Tangle4-8e8af031a803b4af6ef0d5b80d55b878.jpg";